<template>
  <div class="home-content-page-v prediction-car-page">
    <div class="two-content">
      <div class="content-1-1 mii-table">
        <content-title title="每日订单（9月14日）"></content-title>
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th>车号</th>
              <th>仓号</th>
              <th>仓容积</th>
              <th>日期</th>
              <th>订单类型</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(data, index) in showData.slice(start_index, start_index + row_num)">
              <tr v-for="(trData, trIndex) in data.datas">
                <td :class="{'s-bak-td': index % 2 === 0}" :rowspan="data.datas.length" v-if="trIndex === 0">{{data.car}}</td>
                <td v-for="value in trData.slice(1, 5)" :class="{'s-bak-td': index % 2 === 0}">
                  <span>{{value === null ? '' : value}}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="content-1-page">
          <el-pagination small v-on:current-change="pageChange" :page-size="row_num" :total="showData.length" @size-change="handleSizeChange" :page-sizes="[3, 7, 20, 50]" layout="sizes, prev, pager, next">
          </el-pagination>

        </div>
      </div>
      <div class="content-1-2 mii-table">
        <div class="table-tool">
          <a href="javascript:;">
            <i class="iconfont icon-daochu" @click="optPutFile"></i>
          </a>
        </div>
        <content-title title=""></content-title>
        <table style="width: 100%;background: #fff;">
          <thead>
            <tr>
              <th>加油站</th>
              <th>油品</th>
              <th>罐号</th>
              <th>不容纳时间点</th>
              <th>断货时间点</th>
              <th>预计发车时间</th>
              <th>在途时间</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(data, index) in showData.slice(start_index, start_index + row_num)">
              <tr v-for="(trData, trIndex) in data.datas">
                <td v-for="value in trData.slice(5)" :class="{'s-bak-td': index % 2 === 0}">
                  <span>{{value === null ? '' : value}}</span>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <div class="content-2">
      <div class="chat-title">
        图表展示
      </div>
      <div class="chat-block">
        <div class="chat-content">
          <div class="chat-y">
            <div class="chat-y-line">
              <div class="y-top-note" style="text-align: right">
                <span class="">车辆</span>
              </div>
              <div class="one-y" v-for="data in charData">{{data.name}}</div>
            </div>
            <div class="chat-y-data">
              <div class="data-one" v-for="data in charData">
                <div class="data-xian data-xian-sned">
                  <div class="data-num data-send" v-for="oneLine in data.lines" :style="oneLine.style">
                    <div class="data-brn-note">
                      预计发车时间:{{oneLine.start_time}}<br>
                      在途时间:{{oneLine.long}}h
                    </div>
                  </div>
                  <div class="m-line">
                  </div>
                </div>
              </div>
            </div>
            <div class="car-data">
              <div class="one-car-data" v-for="(data, index) in showData.slice(start_index, start_index + row_num)">
                {{data[6]}}
              </div>
            </div>
          </div>

          <div class="chat-x">
            <div class="one-x" style="width: 33%">
              09.14
              <div class="time-start">
                16:00
              </div>
            </div>
            <div class="one-x one-x-last" style="width: 66%">
              09.15
              <div class="time-end">
                16:00
              </div>
            </div>
            <div style="text-align: right;margin-left:1.5rem;">
              <span class="y-top-note">时间</span>
            </div>
          </div>
        </div>
        <div class="chat-info">
          <div class="one-info">
            <div class="dian dian-1">
            </div>
            <span>在途时间</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentTitle from '../components_bit/ContentTitle'
import {
  outPutExcelFile
} from '../cllib'

export default {
  data () {
    return {
      chat: false,
      quy: '昆明',
      start_index: 0,
      row_num: 3,
      change_index: -1,
      search_car: '',
      show_more: false
    }
  },
  components: {
    ContentTitle
  },
  methods: {
    optPutFile () {
      let datas = [{
        data: [],
        sheetName: 'data1'
      }]
      let row1 = ['车号', '仓号', '仓容积', '日期', '订单类型', '加油站', '油品', '罐号', '不容纳时间点', '断货时间点', '预计发车时间', '在途时间']
      datas[0].data.push(row1)
      this.showData.forEach(function (item) {
        item.datas.forEach(function (dataOne) {
          datas[0].data.push(dataOne)
        })
      })
      outPutExcelFile(datas, '每日订单（9月14日）.xls')
    },
    changeCar (index, chat = false) {
      this.chat = chat
      this.change_index = this.change_index === index ? -1 : index
    },
    pageChange (currentPage) {
      this.start_index = (currentPage - 1) * this.row_num
    },
    handleSizeChange (pageSize) {
      this.row_num = pageSize
      this.start_index = 0
    },
    changeOneData (index, carId) {
      this.$store.dispatch('editOnePre', {index, carId})
      this.change_index = -1
    }
  },
  computed: {
    charData: {
      get () {
        let data = []
        let vm = this
        this.showData.slice(vm.start_index, vm.start_index + vm.row_num).forEach(function (item, index) {
          let oneData = {
            name: item.car,
            lines: []
          }
          let startTimes = []
          item.datas.forEach(function (itemOne) {
            let startTime = itemOne[10]
            let long = itemOne[11]
            if (startTimes.indexOf(startTime) === -1) {
              startTimes.push(startTime)
              let width = long / 24 * 100 + '%'
              let num = startTime.slice(3, 5) === '15' ? 8 : 0
              let hour = Number(startTime.slice(6, 8)) < 16 ? Number(startTime.slice(6, 8)) : (Number(startTime.slice(6, 8)) - 16)
              let left = (num + hour + Number(startTime.slice(9)) / 60) / 24 * 100 + '%'
              let lineData = {
                style: {
                  width,
                  left
                },
                start_time: startTime,
                long: long
              }
              oneData.lines.push(lineData)
            }
          })
          data.push(oneData)
        })
        return data
      }
    },
    showData: {
      get () {
        return this.$store.getters.preCarData2
      }
    },
    showOptions: {
      get () {
        let data = []
        let vm = this
        let cars = []
        this.showData.forEach(function (item) {
          cars.push(item[6])
        })
        this.carsInfo.forEach(function (item) {
          if (item[1].indexOf(vm.search_car) > -1 && item[0] === vm.quy && cars.indexOf(item[1]) === -1) {
            data.push(item)
          }
        })
        return data
      }
    },
    preStatus: {
      get () {
        return this.$store.getters.preStatus
      }
    },
    carsInfo: {
      get () {
        return this.$store.getters.carsInfo
      }
    }
  },
  created () {
    if (this.preStatus === 20) {
      this.$store.dispatch('loadCarsInfo')
      this.$store.dispatch('loadPreCarData')
    } else if (this.preStatus < 20) {
      this.$router.push({name: 'single'})
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
@y-width: 5rem;
.table-tool {
  position: absolute;
  right: 1rem;
  top: 0.5rem;
  i {
    font-size: 1.3rem;
    margin-left: 1rem;
    color: #fff;
  }
}
.time-start {
  position: absolute;
  top: 0;
  left: -1rem;
}
.time-end {
  position: absolute;
  top: 0;
  right: -1rem;
}
.content-1-page {
  background: #fff;
  display: flex;
  justify-content: center;
  padding: 0.5em 0;
}
.m-line {
  flex:1;
  height: 1px;
  background-color: #999;
}
.two-content {
  width: 100%;
  display: flex;
  border-radius: 0.5em;
  padding: 0.88em 0.7em 2.25em;
  background-color: #e5e5e5;
}
.show-search {
  display: flex !important;
  z-index: 1000;
}
.select-cars-search {
  display: flex;
  padding: 0.3em 1em 0;
  border-bottom: 1px solid #fff;
  a {
    text-align: center;
    margin-left: 1em;
    margin-top: 0.3em;
    width: 1.2em;
    height: 1.2em;
    font-size: 1.5em;
    line-height: 1.2em;
    color: #081633;
    font-weight: 600;
    background: #fff;
    border-radius: 100%;
  }
}
.icon-change {
  color: #081633;
  padding-left: 0.2em;
}
.cars-infos-div {
  max-height: 20em;
  overflow: auto;
}
.cars-infos {
  color: #fff;
  display: flex;
  div {
    text-align: center;
    flex: 1;
  }
}
.cars-infos-th {
  color: #fff;
  display: flex;
  div {
    text-align: center;
    flex: 1;
  }
}
.cars-infos:hover {
  background-color: #081633;
}
.select-cars {
  position: absolute;
  top: 100%;
  width: 40em;
  display: none;
  color: #fff;
  z-index: 100;
  line-height: 2.5em;
  flex-direction:column;
  background-color: #012e53;
  border-radius: 0.3em;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
}
.car-data-id {
  position: relative;
  width: 9em;
}
.data-num:hover {
  .data-brn-note {
    display:block;
  }
}
.data-brn-note {
  position: relative;
  top: -3em;
  word-break:keep-all;
  white-space:nowrap; 
  height: 3em;
  display: none;
}
.car-data {
  display: flex;
  margin-top: 1.5em;
  flex-direction:column;
  width: 5rm;
}
.one-car-data {
  width: 9em;
  position: relative;
  flex:1;
  display: flex;
  justify-content:center;
  align-items: center;
}

.data-xian-sned {
  position: absolute;
}
.data-none {
  flex:1;
  height: 1px;
  background-color: #999;
}
.data-num {
  position: absolute;
  height: 1rem;
}
.data-send {
  background-color: #00ccff;
}
.data-brn {
  position: relative;
  background-color: #012e53;
}
.data-dh {
  background-color: #6b59cf;
}
.data-xian {
  height: 1rem;
  position:relative;
  width: 100%;
  display: flex;
  align-items: center;
}
.y-top-note {
  height: 1.5em;
  width: 4em;
  white-space:nowrap;
}
.chat-y-data {
  flex: 1;
  display: flex;
  flex-direction:column;
  margin: 1.5em -2.1em 0 0;
}
.chat-x {
  height: 1rem;
  font-size: 0.88em;
  color: #081633;
  display: flex;
  padding-left: @y-width;
  margin-right: 3rem;
}
.one-x {
  text-align: center;
  position: relative;
  border-top: 1px solid #999;
  border-right: 1px solid #999;
}
.one-x-last {
  border-right: 0px solid #999;
}
.one-y {
  border-right: 1px solid #999;
  height: 7em;
  display: flex;
  justify-content:center;
  align-items: center;
}
.chat-y-line {
  width: @y-width;
  min-width: @y-width;
  font-size: 0.88em;
  color: #081633;
  display: flex;
  flex-direction:column;
}
.data-one {
  flex: 1;
  display: flex;
  position: relative;
  align-items: center;
}
.chat-y-data {
  display: flex;
  flex: 1;
  flex-direction:column;
}
.chat-y {
  display: flex;
  width: 100%;
}
.chat-info {
  margin-bottom: 2.7em;
  margin-left: 2.7em;
  display: flex;
  flex-direction:column-reverse;
}
.dian-1 {
  background-color: #00ccff;
}
.dian-2 {
  background-color: #012e53;
}
.dian-3 {
  background-color: #6b59cf;
}
.dian {
  width: 0.5em;
  height: 0.5em;
  margin-right: 1em;
}
.one-info {
  color: #081633;
  font-size: 0.88em;
  height: 2em;
  display: flex;
  align-items: center;
}
.chat-block {
  display: flex;
  width: 85%;
}
.chat-content {
  display: flex;
  flex: 1;
  flex-direction:column;
  padding: 2em;
}
.chat-title {
  color: #0b5591;
  line-height: 1;
  padding-left: 0.5em;
  font-size: 0.94em;
  border-left: 4px solid #0b5591;
}
.i-zhuan {
  transform: rotate(180deg);
}
.zhuang-span {
  transition: 1s;
}
.btn-top-jiao {
  width: 0;
  height: 0;
  border-bottom: 0.81em solid @bak-color-2;;
  border-left: 1.7em solid transparent;
}
.btn-bottom-jiao {
  width: 0;
  height: 0;
  border-top: 0.81em solid @bak-color-2;
  border-right: 1.7em solid transparent;
}
.content-2 {
  padding: 1.88em 2.7em 4.8em;
  display: flex;
  flex-direction:column;
  background: #fff;
  border-radius: 0.5em;
  border-top: 2px dashed #bbb;
}

.content-1-table-1 {
  width: 68%;
}
.content-1-table-2 {
  flex: 1;
  background:#fff;
  margin-left: 0.7em;
  display: flex;
  flex-direction:column;
}
.content-1 {
  background: #fff;
  display: flex;
  flex-direction:column;
}
.content-1-1 {
  background:#fff;
  width: 40%;
  margin-right: 1em;
}
.content-1-2 {
  background:#fff;
  flex: 1;
}
.content-1-tables {
  display: flex;
}
.mii-table-1 {
  background-color: @bak-color-td-2;
}
.mii-table-2 {
  background-color: @bak-color-td-1;
}
.pagination-table {
  text-align: right;
  margin-right: 0.5em;
}
.mii-table {
  position: relative;
  .content-shadow;
  .content-top-radius;
  display: flex;
  flex-direction:column;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.3);
  .data-td {
    width: 10%;
  }
  .s-bak-td {
    background-color: #e0e6ea;
    border:0 solid @bak-color-main;
  }
  .jj-bak-td {
    background-color: @bak-color-2;
    color: #00ccff;
  }
  .ps-bak-td {
    background-color: #98aab9;
  }
  table {
    border-spacing: 0px;
    width: 100%;
    th {
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      line-height: 2.5em;
      color: @bak-color-1;
      font-weight: 100;
      height: 2em;
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis;
    }
    td {
      word-break:keep-all;
      white-space:nowrap;
      text-overflow:ellipsis; 
      height: 2.5em;
      border:0.2px solid @bak-color-main;
      text-align: center;
      font-size: 0.8em;
      color: @bak-color-1;
    }
  }
}
</style>

<style lang="less">
.prediction-car-page .two-content .el-select .el-input .el-input__icon {
  background: rgba(0,0,0,0)
}
</style>



// WEBPACK FOOTER //
// prediction_car.vue?aa1b9b3e